//import axios from 'axios';
import axios from '../utils/axios';

const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";

const getEcxTemplate = (pageNo = 0, pageSize = 50, mediumType = null, search = null) => {
    let url = API_URL + "ecx-templates?pageNo=" + pageNo + "&pageSize=" + pageSize;
    if (mediumType) {
        url += "&mediumType=" + encodeURIComponent(mediumType);
    }
    if (search && String(search).trim()) {
        url += "&search=" + encodeURIComponent(String(search).trim());
    }
    return axios.get(url);
}
const getEcxTemplateById = (templateid) => {
    return axios.get(API_URL + "ecx-templates/" + templateid)
}
const getTemplateTypes = () => {
    return axios.get(API_URL + "reminder-types")
}
const saveEcxTemplate = (data) => {
    return axios.post(API_URL +"ecx-templates", data)
}
const updateEcxTemplate = (templateId, data) => {
    return axios.put(API_URL + "ecx-templates/" + templateId, data)
}
const deleteEcxTemplate = (adminclinicid = 1, templateid) => {
    return axios.delete(API_URL + "clinics/" + adminclinicid + "/ecx-templates/" + templateid)
}
const installTemplates = (data) => {
    return axios.post(API_URL + "ecx-templates/install-to-client", data)
}

//clinic email tempalte
const getEmailTemplates = (clinicid) => {
    return axios.get(API_URL + "clinics/" + clinicid + "/email-templates")
}
const getEmailTemplateById = (clinicid, templateid) => {
    return axios.get(API_URL + "clinics/" + clinicid + "/email-templates/" + templateid)
}
const updateEmailTemplate = (clinicid, templateid, data) => {
    return axios.put(API_URL + "clinics/" + clinicid + "/email-templates/" + templateid, data)
}

//clinic sms tempalte
const getSmsTemplates = (clinicid) => {
    return axios.get(API_URL + "clinics/" + clinicid + "/sms-templates")
}
const getSmsTemplateById = (clinicid, templateid) => {
    return axios.get(API_URL + "clinics/" + clinicid + "/sms-templates/" + templateid)
}
const updateSmsTemplate = (clinicid, templateid, data) => {
    return axios.put(API_URL + "clinics/" + clinicid + "/sms-templates/" + templateid, data)
}
//clinic call tempalte
const getCallTemplates = (clinicid) => {
    return axios.get(API_URL + "clinics/" + clinicid + "/call-templates")
}
const getCallTemplateById = (clinicid, templateid) => {
    return axios.get(API_URL + "clinics/" + clinicid + "/call-templates/" + templateid)
}
const updateCallTemplates = (clinicid, templateid, data) => {
    return axios.put(API_URL + "clinics/" + clinicid + "/call-templates/" + templateid, data)
}
const generateAudio = (clinicid, templateid) => {
    return axios.get(API_URL + "clinics/" + clinicid + "/call-templates/" + templateid + "/audio-samples")
}
const playAudio = (clinicid, templateid) => {
    return axios.get(API_URL + "clinics/" + clinicid + "/call-templates/" + templateid + "/play-audio", {
        responseType: 'arraybuffer'
    })
}



const templateService = {
    getEcxTemplate,
    getTemplateTypes,
    getEcxTemplateById,
    saveEcxTemplate,
    updateEcxTemplate,
    deleteEcxTemplate,
    installTemplates,
    getEmailTemplates,
    getEmailTemplateById,
    updateEmailTemplate,
    getSmsTemplates,
    getSmsTemplateById,
    updateSmsTemplate,
    getCallTemplates,
    getCallTemplateById,
    updateCallTemplates,
    generateAudio,
    playAudio,
}

export default templateService;